import { combineReducers } from "redux";

import cohortsReducer from "./cohorts";
import dashboardReducer from "./dashboard";
import environmentsReducer from "./environments";
import eventTesterReducer from "./eventTester";
import functionDefsReducer from "./functions";
import loginPageReducer from "./loginPage";
import sourcesReducer from "./sources";
import usersReducer from "./users";

const freshpaintReducer = combineReducers({
  environments: environmentsReducer,
  sources: sourcesReducer,
  cohorts: cohortsReducer,
  eventTester: eventTesterReducer,
  dashboard: dashboardReducer,
  functionDefs: functionDefsReducer,
  users: usersReducer,
  loginPage: loginPageReducer,
});

export type FreshpaintState = ReturnType<typeof freshpaintReducer>;

export default freshpaintReducer;
